<template>
    <thead>
        <tr>  
            <th class="pointer" v-click-outside="onClickOutside" @click="openMenu(header)" v-for="header in headers" :key="header.name" :style="(header.width && header.width != '' && header.width != null) ? 'width:'+header.width+';' : ''" :class="header.open ? 'open' : ''">
                {{header.name}}
                <font-awesome-icon 
                :icon="
                (typeof header.dir == 'undefined' || header.dir == '' || header.dir == null) ? 'sort' : 
                (header.dir == 'ASC') ? 'sort-up' : 'sort-down'
                
                " :class="(header.sortable == false && header.filterable == false) ? 'table-sort disabled' : 'table-sort'"></font-awesome-icon>
           

                
                <div @click.stop class="toggle-filter">
                    <b-row v-if="header.sortable == true">
                        <label>Tri</label>
                        <b-form-select v-model="header.dir" :options="sortOptions"></b-form-select>
                    </b-row>
                    <b-row v-if="header.filterable == true">
                        <label>Filtre</label>
                        <b-form-select v-model="header.filter" value-field="id" text-field="name" :options="header.filterData"></b-form-select>
                    </b-row>
                    <b-row class="lst-datatable">
                        <b-button @click="cancel(header)" variant="danger" class="btn-auto mr-2">
                            <font-awesome-icon icon="ban"></font-awesome-icon> Annuler
                        </b-button>
                        <b-button @click="loadGrid(header)" variant="white" class="btn-auto mr-2">
                            <font-awesome-icon icon="check"></font-awesome-icon> Valider
                        </b-button>
                    </b-row>
                </div>
            </th> 
        </tr>
    </thead>
</template>

<script>
import Vuex from 'vuex'
import ClickOutside from 'vue-click-outside'
export default {
    name:"grid",
    computed : {
       
    },
    directives: {
        ClickOutside
    },
    mounted () {
        // prevent click outside event with popupItem.
        this.popupItem = this.$el
    },
    methods : {
        onClickOutside (event) {
           this.headers.forEach(element => {
               this.cancel(element)
            });
        },
        cancel(header){
            if(this.searchSort !== header.code) {
                header.dir = null;
                header.filter = null;
            }
            header.open = false;
        },
        openMenu(header){
            if(header.open == true){
                if(this.searchSort !== header.code) {
                    header.dir = null;
                }
            }

            this.headers.forEach(element => {
                if(element.name != header.name){
                    element.open = false;
                }
            });
            if(header.sortable == true || header.filterable == true) {
                header.open = !header.open
            }

            
        },
        loadGrid(header){
            this.$emit('change',header)
        }
    },
    data: () => ({
        filter : '',
        sortOptions : [
            {value : 'ASC', text : 'Croissant'},
            {value : 'DESC', text : 'Décroissant'}
        ]
    }),
    props :{
        headers: { type: Array, required: true, default: "" },
        searchSort: { type: String, required: true, default: "" },
    }
}
</script>

<style>

</style>